<script>
import DataTableChipColumnVue from 'Arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import ReportTypes from 'Arch/enums/ReportTypes';

export default {
  name: 'ReportTypeColumn',
  extends: DataTableChipColumnVue,
  data: () => ({
    status: ReportTypes,
  }),
};
</script>
